import { N8N_MEALS_URL } from "../constants";

const applyPrices = (record, config) => {
  const fields = { ...record.fields };
  const ttcKey = config.itemPriceFieldTTC;
  const htKey = config.itemPriceFieldHT;
  const tauxTva = fields["Taux Tva"];
  const hasTva =
    tauxTva != null && tauxTva !== "" && Number.isFinite(Number(tauxTva));

  const rawCatalogueTTC = fields[ttcKey];
  const cataloguePriceTTC =
    rawCatalogueTTC != null && rawCatalogueTTC !== ""
      ? Number(rawCatalogueTTC)
      : null;

  let cataloguePriceHT = null;
  if (cataloguePriceTTC != null && hasTva) {
    cataloguePriceHT = cataloguePriceTTC / (1 + Number(tauxTva));
  } else {
    const rawHtBefore = record.fields[htKey];
    if (rawHtBefore != null && rawHtBefore !== "") {
      cataloguePriceHT = Number(rawHtBefore);
    }
  }

  const overrides = config?.pricesOverride ?? {};
  const hasOverride = Object.prototype.hasOwnProperty.call(overrides, record.id);
  const overrideVal = hasOverride ? overrides[record.id] : null;

  if (hasOverride) {
    fields[ttcKey] = overrideVal;
  }

  const ttcAfter = fields[ttcKey];
  if (ttcAfter != null && ttcAfter !== "") {
    const ttcNum = Number(ttcAfter);
    if (hasTva) {
      fields[htKey] = ttcNum / (1 + Number(tauxTva));
    } else if (
      cataloguePriceTTC != null &&
      cataloguePriceHT != null &&
      cataloguePriceTTC !== 0
    ) {
      fields[htKey] = (ttcNum * cataloguePriceHT) / cataloguePriceTTC;
    }
  }

  let priceOverrideHT = null;
  if (hasOverride && overrideVal != null && overrideVal !== "") {
    const ov = Number(overrideVal);
    if (hasTva) {
      priceOverrideHT = ov / (1 + Number(tauxTva));
    } else if (
      cataloguePriceTTC != null &&
      cataloguePriceHT != null &&
      cataloguePriceTTC !== 0
    ) {
      priceOverrideHT = (ov * cataloguePriceHT) / cataloguePriceTTC;
    }
  }

  return {
    ...fields,
    cataloguePriceTTC,
    cataloguePriceHT,
    priceOverrideTTC: hasOverride ? Number(overrideVal) : null,
    priceOverrideHT,
  };
};

export const getMeals = async (config) => {
  const response = await fetch(N8N_MEALS_URL);
  const records = await response.json();

  const recordsById = records.data.reduce((acc, record) => {
    acc[record.id] = record;
    return acc;
  }, {});

  const formattedRecords = records.data.map((record) => {
    if (
      record.fields["Catégorie"] === "Package" &&
      record.fields["Produit (from Produit dans package)"]
    ) {
      return {
        id: record.id,
        fields: {
          ...applyPrices(record, config),
          meals: record.fields["Produit (from Produit dans package)"]
            .map((productId, index) => {
              const mealRecord = recordsById[productId];
              return mealRecord
                ? {
                    id: mealRecord.id,
                    fields: {
                      ...applyPrices(mealRecord, config),
                      quantityInPackage:
                        record.fields["Quantité dans package"]?.[index] || 1,
                    },
                  }
                : null;
            })
            .filter(Boolean),
        },
      };
    }
    return {
      id: record.id,
      fields: applyPrices(record, config),
    };
  });

  return formattedRecords;
};
